import { useState } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Card, Typography, Image, CardContent, Box, Dialog } from '@packages/shared';
import { useCookieConsent } from '@packages/utilities';
import { useIntl } from 'react-intl';
import { loadBeeCardMessages } from './messages';

const LoadbeeFragment = graphql(/* GraphQL */ `
  fragment LoadbeeFragment on Product {
    brand {
      image
      name
    }
    loadbee(locale: $locale) {
      url
    }
  }
`);

export type LoadbeeCardProps = {
  productData: FragmentType<typeof LoadbeeFragment>;
};

export const LoadbeeCard = ({ productData }: LoadbeeCardProps) => {
  const isAllowed = useCookieConsent('C0004');
  const { formatMessage } = useIntl();

  const { brand, loadbee } = getFragmentData(LoadbeeFragment, productData);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  if (!isAllowed || !loadbee) {
    return null;
  }

  return (
    <Card>
      <CardContent
        onClick={() => setIsModalOpen(true)}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {brand?.image && (
          <Box
            sx={{
              mr: 2,
            }}
          >
            <Image
              loading="lazy"
              src={brand.image}
              alt={brand.name}
              style={{ objectFit: 'contain' }}
              width={50}
              height={30}
            />
          </Box>
        )}
        <Typography variant="body1">
          {formatMessage(loadBeeCardMessages.labelText, {
            brand: brand?.name || '',
          })}
        </Typography>
      </CardContent>

      <Dialog
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        size="xl"
        // TOOD: ask UX for fallback headline
        title={formatMessage(loadBeeCardMessages.modalHeadline, {
          brand: brand?.name || '',
        })}
        dialogContent={<iframe title="title" src={loadbee.url} width="100%" height="100%" />}
        sx={{
          '.MuiDialogContent-root': {
            overflow: 'hidden',
          },
          '.MuiPaper-root': {
            height: '100%',
          },
        }}
      />
    </Card>
  );
};
